import persistedState from 'vuex-persistedstate'
import state from './state'
import * as mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  plugins: [
    persistedState ({
      key: 'localStorage',
      storage: window.localStorage,
      reducer: (data) => {
        return {
          userInfo: data.userInfo,
          activeMenu: data.activeMenu,
          userCouponInfo: data.userCouponInfo,
        }
      }
    }),
    persistedState ({
      key: 'sessionStorage',
      storage: window.sessionStorage,
      reducer: (data) => {
        return {
          userInfo: data.userInfo,
          activeMenu: data.activeMenu
        }
      }
    })
  ]
})
